import React from 'react';
const SendVector = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M21.001 10.4667C21.0019 10.8889 20.8818 11.3026 20.6546 11.6598C20.4275 12.017 20.1026 12.303 19.7177 12.4845L3.22691 20.2213C2.92509 20.3843 2.59073 20.4794 2.24759 20.5C1.87209 20.4992 1.50275 20.4054 1.17319 20.2272C0.843638 20.0489 0.564336 19.7919 0.360715 19.4794C0.157095 19.167 0.0356245 18.809 0.00736267 18.4382C-0.0208992 18.0674 0.0449454 17.6954 0.198902 17.3562L2.76539 11.5815H9.00151C9.30005 11.5815 9.58637 11.4641 9.79747 11.255C10.0086 11.046 10.1272 10.7624 10.1272 10.4667C10.1272 10.1711 10.0086 9.88752 9.79747 9.67845C9.58637 9.46938 9.30005 9.35193 9.00151 9.35193H2.76539L0.198902 3.63297C0.0129347 3.21738 -0.0403245 2.75542 0.0462622 2.30901C0.132849 1.8626 0.355145 1.45307 0.683356 1.13529C1.01157 0.817523 1.43001 0.606697 1.88261 0.531073C2.33521 0.455448 2.80034 0.518639 3.21565 0.712175L19.7065 8.44894C20.0934 8.62886 20.4206 8.91416 20.6499 9.27149C20.8791 9.62881 21.0009 10.0434 21.001 10.4667Z"
        fill={color}
      />
    </svg>
  );
};

export default SendVector;
